import "../scss/style.scss";

import "./functions/smooth-scroll";  

import "./template-parts/header";
import "./template-parts/home-hero";
import "./template-parts/apartment-slider";
import "./template-parts/apartment-gallery"; 
import "./template-parts/blog-posts-list";
import "./template-parts/contact-map"; 
import "./template-parts/language-switcher"; 
 
